import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useState } from "react";
import NotificationPopUp from "util/NotificationPopUp";
import {JobInfoDTO} from "../../../serviceapi/jobRunnerApi";

interface AddNewJobDialogProps {
  isVisible: boolean;
  setIsVisible: (isVisible: boolean) => void;
  onJobCreated: (job: JobInfoDTO) => void;
  existingJobs: JobInfoDTO[];
}

const defaultJob: JobInfoDTO = {
  taskId: "",
  taskTitle: "",
  enabled: false,
  schedule: {
    cron: "0/30 * * * * ? *",
    timeZone: "UTC",
  },
};

const AddNewJobDialog = ({
  isVisible,
  setIsVisible,
  existingJobs,
  onJobCreated,
}: AddNewJobDialogProps) => {
  const [currentJob, setCurrentJob] = useState<JobInfoDTO>(defaultJob);
  const [error, setError] = useState<string>("");

  const handleCreate = async () => {
    const taskId = currentJob.taskId.trim();
    const taskTitle = currentJob.taskTitle?.trim();

    if (!taskId || !taskTitle) {
      setError("Both Task ID and Title are required.");
      return;
    }

    const taskExists = existingJobs.some((job) => job.taskId === taskId);
    if (taskExists) {
      setError("Task ID already exists.");
      return;
    }

    try {
      onJobCreated(currentJob);
      handleHideDialog();
    } catch (error) {
      console.error("Error creating job:", error);
      NotificationPopUp.show("Failed to create job.", "error");
    }
  };

  const handleHideDialog = () => {
    setIsVisible(false);
    setError("");
  };

  return (
    <Dialog
      header="Create New Job"
      visible={isVisible}
      onHide={handleHideDialog}
      style={{ width: "400px" }}
      modal
    >
      <div className="p-fluid flex flex-column gap-3">
        <div className="p-field">
          <label htmlFor="taskId">Task ID *</label>
          <InputText
            id="taskId"
            value={currentJob.taskId}
            onChange={(e) =>
              setCurrentJob({ ...currentJob, taskId: e.target.value })
            }
          />
        </div>
        <div className="p-field">
          <label htmlFor="taskTitle">Task Title *</label>
          <InputText
            id="taskTitle"
            value={currentJob.taskTitle || ""}
            onChange={(e) =>
              setCurrentJob({ ...currentJob, taskTitle: e.target.value })
            }
          />
        </div>
        {error && <div style={{ color: "red" }}>{error}</div>}
        <Button label="Create Job" onClick={handleCreate} className="mt-3" />
      </div>
    </Dialog>
  );
};

export default AddNewJobDialog;
